// Copyright 2023 Sorama B.V.
import { DialogController } from "aurelia-dialog";
import { autoinject } from "aurelia-framework";
import { ProjectDTO } from "datatypes/SoramaWebApi";
import { IProjectManagementService } from "services/Project/IProjectManagementService";

export interface ProjectSelectionModel {
    title?: string;
    text?: string;
    selectText?: string;
    filter?: (project: ProjectDTO) => boolean;
}

@autoinject
export class ProjectSelectionDialog {
    private model: ProjectSelectionModel = {
        title: "Project Selection",
        text: "Please select a project from the list below",
        selectText: "Select",
        filter: (project: ProjectDTO) => true,
    };

    private projects: ProjectDTO[];
    private selectedProject: ProjectDTO;

    constructor(
        private readonly controller: DialogController,
        private readonly projectManagementService: IProjectManagementService
    ) {}

    public async activate(model: ProjectSelectionModel): Promise<void> {
        this.model = { ...this.model, ...model };
        this.projectManagementService
            .getProjects()
            .readToEnd()
            .then((projects) => {
                this.projects = projects.filter(this.model.filter);

                // If we have a current project, select it, otherwise select the first project in the list
                this.selectedProject = this.projectManagementService.currentProject.item ?? this.projects[0];
            });
    }

    private selectProject(): void {
        this.controller.ok(this.selectedProject);
    }

    protected close(): void {
        this.controller.cancel();
    }
}
